import React from 'react';
import {Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Colors} from 'chart.js';
import {Line} from "react-chartjs-2";
import {useAppSelector} from "../../../../../helpers/redux";
import { LineChartModel } from '../../models';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Colors
);
const JobStatisticChart = () => {
    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top' as const,
            },
            title: {
                display: true,
                text: 'Job Statistic Chart',
            },
        },
    };

    const jobStatisticChart = useAppSelector(
        (state) => state.jobReport.jobStatisticChartList ?? {
            labels: [],
            datasets: [],
        } as LineChartModel
    );

    return (
        <div>
            <div className="mt-3">
                <div className="main-data-grid fielding mt-5">
                    <Line options={options} data={jobStatisticChart} />
                </div>
            </div>
        </div>
    );
};

export default JobStatisticChart;
